module.exports = require("@carvana/icons/ArrowDown");